module.exports = __webpack_public_path__ + "img/aurora-high-angle.d602113d.png";